import { useQuery } from 'react-query'

import { QUERY_KEYS } from '@api'

import { getPendings } from './api'

const usePendings = () => {
  return useQuery<number>([QUERY_KEYS.PENDINGS], getPendings, {
    refetchInterval: 30_000,
    refetchOnWindowFocus: false,
    onError: (error: unknown) => {
      if (error instanceof Error) {
        console.error('Error fetching pendings:', error.message)
      } else {
        console.error('Unknown error fetching pendings:', error)
      }
    },
  })
}

export { usePendings }
